import React from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export default function CardDrag({
  item,
  index,
  handleChanged,
  renderTooltipActiveInactive,
  activeInactiveClicked,
  renderTooltipDelete,
  handleDelete,
  isUniqueId,
  masterAddEditAccess,
  masterDeleteAccess,
}) {
  const { t } = useTranslation('common');
  return (
    <div className="list-container">
      <li key={index}>
        <div className="input-container">
          <div className="d-flex">
            <input
              key={index}
              name="measurementMaster"
              value={item?.name ? item?.name : ''}
              autoFocus={!item?._id}
              placeholder={t('CARD_DRAG.ENTER_ECOMM_SPEC')}
              type="text"
              disabled={!masterAddEditAccess}
              onChange={(e) => handleChanged(e, index)}
            />
          </div>

          {isUniqueId && isUniqueId.length !== 0 && isUniqueId.includes(index) && (
            <label className="text-danger m-0 p-1">{t('CARD_DRAG.ENTRY_ALREADY_EXISTS')}</label>
          )}

          {item.isEmpty && (item.name === null || item.name === '') && <label className="text-danger m-0 p-1">{t('CARD_DRAG.E_COMM_SPEC_REQUIRED')}</label>}

          {item.isNew && item.name && item.name.length && !item.name.trim().length && (
            <label className="text-danger m-0 p-1">{t('CARD_DRAG.INVALID_ENTRY')}</label>
          )}
        </div>
        <div className="input-action">
          {item?._id !== '' && masterAddEditAccess && (
            <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
              <button
                onClick={() => activeInactiveClicked(item?._id, 'measurementMaster')}
                id={item?._id}
                type="button"
                aria-label={item?.isActive ? 'Active' : 'Inactive'}
              >
                <span className={item?.isActive ? 'icon-active' : 'icon-inactive'} />
              </button>
            </OverlayTrigger>
          )}
          {masterDeleteAccess && (
            <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
              <button
                type="button"
                aria-label="Delete"
                onClick={() => {
                  handleDelete(item?._id ? item?._id : index, 'measurementMaster');
                }}
              >
                <span className="icon-delete mt-3 f-20" />
              </button>
            </OverlayTrigger>
          )}
        </div>
      </li>
    </div>
  );
}
